import type {Result, UseCase} from 'framework';
import type {SavedMealError} from '../../domain/errors';
import type {RecentLineIngredient} from '../../domain/recent-line-ingredient';
import type {
  ListRecentLineIngredientsInput,
  SavedMealRepository,
} from '../ports/saved-meal.repository';

export class ListRecentLineIngredients implements UseCase<
  [ListRecentLineIngredientsInput],
  readonly RecentLineIngredient[]
> {
  constructor(private readonly repository: SavedMealRepository) {}

  execute(
    input: ListRecentLineIngredientsInput,
  ): Promise<Result<readonly RecentLineIngredient[], SavedMealError>> {
    return this.repository.listRecentLineIngredients(input);
  }
}
